@if (isOpen) {
<div
  class="vw-celebration fixed inset-0 z-[1000] flex items-center justify-center px-6"
  role="dialog"
  aria-modal="true"
  (click)="close()"
>
  <div class="absolute inset-0 bg-[#062825]/70 backdrop-blur-sm"></div>

  <!-- Confettis : purement décoratifs, donc masqués aux lecteurs d'écran -->
  <div class="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
    @for (c of confetti; track $index) {
    <span
      class="vw-confetti"
      [style.left.%]="c.left"
      [style.background]="c.color"
      [style.animation-delay.s]="c.delay"
      [style.animation-duration.s]="c.duration"
      [style.--vw-tilt]="c.tilt + 'deg'"
    ></span>
    }
  </div>

  <div
    class="vw-celebration-card relative w-full max-w-sm rounded-3xl bg-white px-6 pb-6 pt-0 text-center shadow-2xl"
  >
    <!-- Willy déborde de la carte : il annonce la nouvelle, il n'illustre pas -->
    <img
      src="/assets/images/willy/willy_perfecto.png"
      alt=""
      aria-hidden="true"
      class="vw-celebration-willy mx-auto -mt-16 h-32 w-32 object-contain"
    />

    <span
      class="mt-1 inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#F79400] to-[#F0C97A] px-3 py-1 text-xs font-semibold uppercase tracking-wide text-white"
    >
      {{ 'premium.celebration.badge' | translate }}
    </span>

    <!-- `text-balance` évite qu'un titre traduit laisse un « ! » seul sur sa
         ligne : les six langues n'ont pas la même longueur. -->
    <h2 class="mt-3 text-balance text-2xl font-semibold leading-tight text-[#062825]">
      {{
        (trial
          ? 'premium.celebration.title-trial'
          : 'premium.celebration.title'
        ) | translate
      }}
    </h2>

    <p class="mt-2 text-pretty text-sm leading-relaxed text-[#617069]">
      {{
        (trial
          ? 'premium.celebration.subtitle-trial'
          : 'premium.celebration.subtitle'
        ) | translate
      }}
    </p>

    <ul class="mt-4 flex flex-col gap-2 text-left">
      @for (k of ['lunar', 'harvest', 'willy', 'garden']; track k) {
      <li class="flex items-start gap-2.5">
        <span
          class="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#EAF5EF] text-[#317756]"
        >
          <svg viewBox="0 0 24 24" class="h-3 w-3" fill="none" aria-hidden="true">
            <path
              d="M5 13l4 4L19 7"
              stroke="currentColor"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span class="text-sm text-[#062825]">
          {{ 'premium.celebration.perks.' + k | translate }}
        </span>
      </li>
      }
    </ul>

    <button
      type="button"
      class="mt-5 w-full rounded-full bg-primary py-3 text-sm font-semibold text-white"
      (click)="close()"
    >
      {{ 'premium.celebration.cta' | translate }}
    </button>
  </div>
</div>
}
